import React, { createContext, useContext, useEffect, useState } from 'react';

import { getCookie } from '../../../common/helper';
import useGetLicenseInfo from '../hooks/useGetLicenseInfo';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { TResponseGetLicenseInfo } from '../hooks/useGetLicenseInfo/type';

type TLicenseContext = {
  response?: TResponseGetLicenseInfo;
};

const LicenseContext = createContext<TLicenseContext | null>(null);

export const useLicense = () => {
  const context = useContext(LicenseContext);
  if (!context) {
    throw new Error('useLicense must be used inside scope LicenseProvider');
  }
  return context;
};

// export const LicenseProvider = ({ children }: { children: React.ReactNode }) => {
//   const location = useLocation();
//   const prevLocationRef = useRef<string>();
//   const { response, handleGetLicenseInfo } = useGetLicenseInfo();

//   useEffect(() => {
//     if (prevLocationRef.current === '/companies/select' && location.pathname !== '/companies/select') {
//       handleGetLicenseInfo();
//     }

//     prevLocationRef.current = location.pathname;
//   }, [location.pathname]);

//   useEffect(() => {
//     handleGetLicenseInfo();
//   }, []);

//   return <LicenseContext.Provider value={{ response }}>{children}</LicenseContext.Provider>;
// };

export const LicenseProvider = ({ children }: { children: React.ReactNode }) => {
  const { response, handleGetLicenseInfo } = useGetLicenseInfo();

  const [orgId, setOrgId] = useState<string>();

  useEffect(() => {
    if (getCookie(BIGDATA_CONSTANT.orgIdForGetLicenseInfo))
      setOrgId(getCookie(BIGDATA_CONSTANT.orgIdForGetLicenseInfo));
  }, [getCookie(BIGDATA_CONSTANT.orgIdForGetLicenseInfo)]);

  useEffect(() => {
    if (orgId) handleGetLicenseInfo();
  }, [orgId]);

  return <LicenseContext.Provider value={{ response }}>{children}</LicenseContext.Provider>;
};
